import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Card, Button, Row, Col } from 'react-bootstrap';
import MasterSidebar from '@rd-web-markets/shared/dist/util/MasterSidebar';
import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
import ChecklistTemplateList from './ChecklistTemplateList';
import ChecklistTemplateForm from './ChecklistTemplateRowForm';
import checklistTemplateService from './checklist_template.service';
import checklistRowsService from './checklist_rows.servce';

const ChecklistTemplatePage = () => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);

  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const {
    templates,
    createTemplate,
  } = checklistTemplateService.useCrud(setLoading);

  const currentTemplate = templates && templates.length > 0 ? templates[0] : null;

  const {
    rows,
    setRows,
    createRow,
    updateRow,
    deleteRow,
    reorderRows,
  } = checklistRowsService.useCrud(setLoading, currentTemplate?.id);

  const handleCreateTemplate = async () => {
    setLoading(true);
    try {
      await createTemplate();
    } catch (error) {
      console.error('Failed to create template', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateRow = async (formData) => {
    setLoading(true);
    try {
      await createRow(formData);
      setShowForm(false);
    } catch (error) {
      console.error('Failed to create row', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateOrder = async (reorderedRows) => {
    await reorderRows(reorderedRows);
    setRows([...reorderedRows]);
  };

  return (
    <>
    <Row className='justify-content-center mx-0 mt-4'>
      <Col md={10}>

        <Card className="mt-3">
          <Card.Header>{t('checklist_template')}</Card.Header>
            <Card.Body>
              {!currentTemplate ? (
                <div className="text-center py-5">
                  <p className="text-muted mb-3">{t('no_template_exists')}</p>
                  <Button
                    variant="primary"
                    disabled={loading}
                    onClick={handleCreateTemplate}
                  >
                    {loading ? t('creating') : t('create_template')}
                  </Button>
                </div>
              ) : (
                <>
                  <div className="d-flex justify-content-start mb-3">
                    <AddButton
                      variant="info"
                      disabled={loading}
                      onClick={() => setShowForm((prev) => !prev)}
                      text={showForm ? t('hide_form') : t('add_checklist_row')}
                    />
                  </div>

                  {showForm && (
                    <ChecklistTemplateForm onSubmit={handleCreateRow} loading={loading} />
                  )}

                  <Card>
                    <ChecklistTemplateList
                      rows={rows}
                      onUpdate={updateRow}
                      onDelete={deleteRow}
                      onUpdateOrder={handleUpdateOrder}
                    />
                  </Card>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ChecklistTemplatePage;